import forEach from 'lodash/forEach';
import format from 'date-fns/format';
import {toUTC} from 'common/dates';
import useTransLoader from 'i18n/use-trans-loader';
import {useRouteMatch} from 'react-router-dom';
import get from 'lodash/get';
import Table from '@livongo/ui/Table';
import cssTable from '../coaching/Coaching.scss';
import css from './medication-reconciliation.scss';

const ImportedMedications = prop => {
    const {path} = useRouteMatch();
    const {t} = useTransLoader(path);
    const importedMedicationLists = get(prop, 'importedMedList');
    const importedMed = [];

    function modifyMedList() {
        forEach(importedMedicationLists, (medication, key) => {
            importedMed.unshift({
                medType: get(medication, 'medClass'),
                medName: `${get(medication, 'drugName')}, ${get(
                    medication,
                    'strength'
                )}${get(medication, 'strengthUnit')}`,
                category: get(medication, 'gpi6Name'),
                dose: `${get(medication, 'strength')}${get(
                    medication,
                    'strengthUnit'
                )}, ${get(medication, 'directions')}`,
                routes: get(medication, 'medRoute'),
                startDate: format(toUTC(medication.startDate), 'MM/dd/yyyy'),
            });
        });
    }

    return (
        <div className={css['medication-reconciliation']}>
            <div
                id="medication-imported-panel"
                className="panel panel-default div-table"
                style={{fontSize: '12px'}}
            >
                {modifyMedList()}
                <div className="panel panel-default">
                    {importedMed.length > 0 ? (
                        <Table
                            className={cssTable.table}
                            noDataAvailableMessage="None"
                            columns={[
                                {
                                    Header: t(''),
                                    accessor: 'medType',
                                    className: cssTable.head,
                                },
                                {
                                    Header: t('headers.name'),
                                    accessor: 'medName',
                                    className: cssTable.head,
                                },
                                {
                                    Header: t('headers.category'),
                                    accessor: 'category',
                                    className: cssTable.head,
                                },
                                {
                                    Header: t('headers.dose'),
                                    accessor: 'dose',
                                    className: cssTable.head,
                                },
                                {
                                    Header: t('headers.routes'),
                                    accessor: 'routes',
                                    className: cssTable.head,
                                },
                                {
                                    Header: t('headers.startDate'),
                                    accessor: 'startDate',
                                    className: cssTable.head,
                                },
                            ]}
                            data={importedMed}
                        />
                    ) : (
                        <div className="panel-body">
                            <p>{t('noData')}</p>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default ImportedMedications;
